import FooterMid from "./FooterMid/FooterMid";
import NewsLetter from "./NewsLetter/NewsLetter";


const Footer = () => {
  return (
    <footer>
      <NewsLetter />
      <FooterMid />
    </footer>
  );
};

export default Footer;